export class User {
    id: string;
    created: Date;
    updated: Date;
    name: string;
    email: string;
    isAdmin: boolean;
    isModerator: boolean;
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/user.ts